// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ContentWrapper_contentWrapper__Ra5gO"};